/*
 * BITCO brand size-chart popup.
 * The variant picker renders one hidden [data-bitco-sizechart] dialog per PDP
 * (the vendor's size-chart page content). The "Size guide" button opens it;
 * scrim / close button / Esc dismiss it. Delegated so it works regardless of
 * where the picker sits in the DOM.
 */
(function () {
  var modal = null;

  function open() {
    modal = document.querySelector('[data-bitco-sizechart]');
    if (!modal) return;
    modal.removeAttribute('hidden');
    document.documentElement.classList.add('bitco-sizechart-open');
    document.addEventListener('keydown', onKey);
    var closeBtn = modal.querySelector('.bitco-sizechart__close');
    if (closeBtn) closeBtn.focus();
  }

  function close() {
    if (!modal) modal = document.querySelector('[data-bitco-sizechart]');
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.documentElement.classList.remove('bitco-sizechart-open');
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-bitco-sizechart-open]')) {
      e.preventDefault();
      open();
    } else if (e.target.closest('[data-bitco-sizechart-close]')) {
      close();
    }
  });
})();
